import React, { useEffect, useState } from "react";
import { Trash, Check, Envelope, EnvelopeOpen, Phone } from "@phosphor-icons/react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminContacts() {
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/admin/contacts").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const toggleRead = async (c, read) => {
    await api.patch(`/admin/contacts/${c.id}/read?read=${read}`);
    load();
    if (selected?.id === c.id) setSelected({ ...c, read });
  };

  const del = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/admin/contacts/${id}`);
    if (selected?.id === id) setSelected(null);
    load();
  };

  const unreadCount = list.filter((c) => !c.read).length;

  return (
    <div className="p-8 md:p-10" data-testid="admin-contacts">
      <div className="mb-8">
        <div className="overline mb-2">Inbox</div>
        <h1 className="font-display text-5xl uppercase text-white leading-none">Messages</h1>
        <p className="text-white/60 mt-2 text-sm">{unreadCount} unread · {list.length} total</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[400px_1fr] gap-4">
        <div className="admin-card p-0 max-h-[70vh] overflow-y-auto">
          {list.length === 0 ? (
            <div className="p-10 text-center text-white/50 text-sm">No messages yet.</div>
          ) : (
            <ul className="divide-y divide-[#2a2a2a]">
              {list.map((c) => (
                <li key={c.id}>
                  <button onClick={() => { setSelected(c); if (!c.read) toggleRead(c, true); }} className={`w-full text-left p-4 hover:bg-[#242424] ${selected?.id === c.id ? "bg-[#242424] border-l-2 border-atc-red" : ""}`} data-testid={`msg-${c.id}`}>
                    <div className="flex items-center justify-between gap-2">
                      <div className="flex items-center gap-2 min-w-0">
                        {!c.read ? <Envelope size={14} weight="fill" className="text-atc-red shrink-0" /> : <EnvelopeOpen size={14} className="text-white/40 shrink-0" />}
                        <span className={`font-heading uppercase text-sm truncate ${c.read ? "text-white/70" : "text-white"}`}>{c.name}</span>
                      </div>
                      <span className="font-mono text-[10px] text-white/40 shrink-0">{new Date(c.created_at).toLocaleDateString()}</span>
                    </div>
                    <p className="text-white/50 text-xs mt-1 line-clamp-1">{c.service || "General"} · {c.message}</p>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="admin-card">
          {!selected ? (
            <div className="text-center text-white/40 py-20">Select a message to read</div>
          ) : (
            <div data-testid="msg-detail">
              <div className="flex items-start justify-between gap-4 mb-6">
                <div>
                  <h2 className="font-display text-3xl uppercase text-white leading-none">{selected.name}</h2>
                  <div className="font-mono text-xs text-white/50 mt-2">{new Date(selected.created_at).toLocaleString()}</div>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => toggleRead(selected, !selected.read)} className="border border-[#333] hover:border-atc-red p-2 flex items-center gap-2 text-xs font-heading uppercase tracking-widest" data-testid="toggle-read">
                    <Check size={14} weight="bold" /> {selected.read ? "Mark unread" : "Mark read"}
                  </button>
                  <button onClick={() => del(selected.id)} className="border border-[#333] hover:border-atc-red p-2" data-testid="delete-msg"><Trash size={14} weight="bold" /></button>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                <div><div className="font-mono text-[10px] uppercase tracking-widest text-white/40">Email</div><a href={`mailto:${selected.email}`} className="text-white hover:text-atc-red break-all">{selected.email}</a></div>
                {selected.phone && (<div><div className="font-mono text-[10px] uppercase tracking-widest text-white/40">Phone</div><a href={`tel:${selected.phone}`} className="text-white hover:text-atc-red flex items-center gap-1"><Phone size={12} weight="bold" /> {selected.phone}</a></div>)}
                {selected.service && (<div><div className="font-mono text-[10px] uppercase tracking-widest text-white/40">Service</div><div className="text-white">{selected.service}</div></div>)}
              </div>
              <div className="border-t border-[#2a2a2a] pt-5">
                <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">Message</div>
                <p className="text-white/90 whitespace-pre-wrap leading-relaxed">{selected.message}</p>
              </div>
              <div className="mt-6 pt-5 border-t border-[#2a2a2a] flex gap-3">
                <a href={`mailto:${selected.email}`} className="btn-primary">Reply via Email</a>
                {selected.phone && <a href={`tel:${selected.phone}`} className="btn-ghost-white">Call {selected.phone}</a>}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
